"use client";

import Breadcrumbs from "@/components/entities/breadcrumbs";
import { useTranslations } from "next-intl";
import S from "./index.module.scss";
import { useAddressesData } from "../../hooks/useAddressesData";
import AddressesItem from "./addresses-list-item";
import { observer } from "mobx-react-lite";
import { useStore } from "@/hooks/system/useStore";

const AddressesList = () => {
  const t = useTranslations();
  const { query } = useStore("addresses");
  const { addresses } = useAddressesData(query);

  const breadcrumbs = [{ title: t("home"), url: "/" }];

  return (
    <div className={S.wrapper}>
      <div>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        <h1 className={S.title}>{t("findDealer")}</h1>
      </div>
      <ul className={S.list}>
        {addresses?.length
          ? addresses?.map((item, idx) => <AddressesItem key={idx} item={item} />)
          : t("noResults", { query: query || "" })}
      </ul>
    </div>
  );
};

export default observer(AddressesList);
